"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Select_component_exports = {};
__export(Select_component_exports, {
  Select: () => Select
});
module.exports = __toCommonJS(Select_component_exports);
var import_react = __toESM(require("react"));
var import_react2 = require("@floating-ui/react");
var import_useViewport = require("../../../utils/useViewport/useViewport.hook");
var import_Helpers = require("../../../utils/Helpers");
var import_baseThemeTailwindcss = require("../../../themes/baseThemeTailwindcss");
var import_atoms = require("../../atoms");
var import_Select = require("./Select.context");
var import_Dropdown = require("./Dropdown/Dropdown.component");
var import_Label = require("./Label/Label.component");
var import_DropdownList = require("./DropdownList/DropdownList.component");
__reExport(Select_component_exports, require("./Option/Option.component"), module.exports);
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var isReactComponent = function isReactComponent2(element) {
  return element !== null && _typeof(element) === "object" && "props" in element;
};
var Select = function Select2(_ref) {
  var defaultIndex = _ref.defaultIndex, children = _ref.children, responsiveLogo = _ref.responsiveLogo, floatingMargin = _ref.floatingMargin, _ref$dropdownPosition = _ref.dropdownPosition, dropdownPosition = _ref$dropdownPosition === void 0 ? "bottom" : _ref$dropdownPosition, _ref$shouldUpdateDefa = _ref.shouldUpdateDefaultSelected, shouldUpdateDefaultSelected = _ref$shouldUpdateDefa === void 0 ? false : _ref$shouldUpdateDefa, _ref$removeBtnMargin = _ref.removeBtnMargin, removeBtnMargin = _ref$removeBtnMargin === void 0 ? false : _ref$removeBtnMargin, role = _ref.role;
  var isDefaultIndex = Number.isInteger(defaultIndex) ? defaultIndex : null;
  var isDefaultChild = children[defaultIndex] || null;
  var checkDefaultChild = isDefaultChild.props !== void 0 ? isDefaultChild.props.children : isDefaultChild;
  var _useState = (0, import_react.useState)(false), _useState2 = _slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
  var _useState3 = (0, import_react.useState)(null), _useState4 = _slicedToArray(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
  var _useState5 = (0, import_react.useState)(isDefaultIndex), _useState6 = _slicedToArray(_useState5, 2), selectedIndex = _useState6[0], setSelectedIndex = _useState6[1];
  var _useState7 = (0, import_react.useState)(checkDefaultChild), _useState8 = _slicedToArray(_useState7, 2), selectedOption = _useState8[0], setSelectedOption = _useState8[1];
  var _useViewport = (0, import_useViewport.useViewport)(), width = _useViewport.width;
  var _useState9 = (0, import_react.useState)(""), _useState10 = _slicedToArray(_useState9, 2), label = _useState10[0], setLabel = _useState10[1];
  var isFirstRender = (0, import_react.useRef)(true);
  var moreThanOneChildren = Array.isArray(children) && children.length > 1;
  var breakpointMdScreen = parseInt(import_baseThemeTailwindcss.baseThemeTailwindcss.theme.screens.md, 10);
  var adjustPlacement = width < breakpointMdScreen ? "".concat(dropdownPosition, "-end") : "".concat(dropdownPosition, "-start");
  var fallbackPlacements = [dropdownPosition, "".concat(dropdownPosition, "-start"), "".concat(dropdownPosition, "-end")];
  var _useFloating = (0, import_react2.useFloating)({
    placement: adjustPlacement,
    open: isOpen,
    onOpenChange: setIsOpen,
    whileElementsMounted: import_react2.autoUpdate,
    middleware: [(0, import_react2.flip)({
      fallbackPlacements
    }), (0, import_react2.size)({
      apply: function apply(_ref2) {
        var elements = _ref2.elements, availableHeight = _ref2.availableHeight, availableWidth = _ref2.availableWidth;
        Object.assign(elements.floating.style, {
          maxHeight: "".concat(availableHeight, "px"),
          maxWidth: "".concat(availableWidth, "px")
        });
      },
      padding: 10
    })]
  }), refs = _useFloating.refs, floatingStyles = _useFloating.floatingStyles, context = _useFloating.context;
  var elementsRef = (0, import_react.useRef)([]);
  var labelsRef = (0, import_react.useRef)([]);
  var modifiedFloatingStyles = _objectSpread(_objectSpread(_objectSpread({}, floatingStyles), width <= breakpointMdScreen && {
    "marginTop": "0.5rem"
  }), {
    "overflowX": "hidden"
  });
  var handleSelect = (0, import_react.useCallback)(function(index, child) {
    setSelectedIndex(index);
    setIsOpen(false);
    if (index !== null) {
      setSelectedOption(child);
    }
  }, []);
  function handleTypeaheadMatch(index) {
    if (isOpen) {
      setActiveIndex(index);
    } else {
      handleSelect(index);
    }
  }
  var listNav = (0, import_react2.useListNavigation)(context, {
    listRef: elementsRef,
    activeIndex,
    selectedIndex,
    onNavigate: setActiveIndex,
    loop: true,
    focusItemOnHover: false
  });
  var typeahead = (0, import_react2.useTypeahead)(context, {
    listRef: labelsRef,
    activeIndex,
    selectedIndex,
    onMatch: handleTypeaheadMatch
  });
  var click = (0, import_react2.useClick)(context);
  var dismiss = (0, import_react2.useDismiss)(context, {});
  var containerRole = role === "flyoutMenu" ? "menu" : "listbox";
  var activeRole = (0, import_react2.useRole)(context, {
    role: moreThanOneChildren ? containerRole : "label"
  });
  var _useInteractions = (0, import_react2.useInteractions)([listNav, typeahead, click, dismiss, activeRole]), getReferenceProps = _useInteractions.getReferenceProps, getFloatingProps = _useInteractions.getFloatingProps, getItemProps = _useInteractions.getItemProps;
  var referenceProps = getReferenceProps();
  var selectContext = (0, import_react.useMemo)(function() {
    return {
      activeIndex,
      selectedIndex,
      getItemProps,
      handleSelect,
      selectedOption,
      isDefaultIndex,
      setLabel,
      moreThanOneChildren
    };
  }, [activeIndex, isDefaultIndex, selectedIndex, getItemProps, handleSelect, setLabel, moreThanOneChildren]);
  var hasSelectedOption = isReactComponent(selectedOption);
  var renderButtonContent = function renderButtonContent2() {
    if (hasSelectedOption) {
      if (width <= breakpointMdScreen && responsiveLogo) {
        return /* @__PURE__ */ import_react.default.createElement("span", _extends({}, moreThanOneChildren && {
          role: "button"
        }, {
          style: {
            marginTop: "0.5rem"
          },
          "aria-label": label
        }), !moreThanOneChildren && /* @__PURE__ */ import_react.default.createElement(import_atoms.ScreenReaderOnlyText, {
          text: label
        }), selectedOption.props.children[0]);
      }
      return selectedOption;
    }
    return "Select ...";
  };
  var onKeyDown = function onKeyDown2(e) {
    if (e.key === "Tab") {
      setIsOpen(false);
      e.preventDefault();
    }
  };
  (0, import_react.useEffect)(function() {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!isOpen) {
      setTimeout(function() {
        if (refs.reference.current && refs.reference.current instanceof HTMLButtonElement) {
          refs.reference.current.focus();
        }
      }, 10);
    }
    if (import_Helpers.hasDocument) {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "inherit";
      }
    }
  }, [isOpen]);
  (0, import_react.useEffect)(function() {
    if (shouldUpdateDefaultSelected) {
      var newDefaultChild = children[defaultIndex] || null;
      var newCheckDefaultChild = (newDefaultChild === null || newDefaultChild === void 0 ? void 0 : newDefaultChild.props) !== void 0 ? newDefaultChild.props.children : newDefaultChild;
      if (isDefaultIndex !== null && newCheckDefaultChild !== null) {
        setSelectedIndex(isDefaultIndex);
        setSelectedOption(newCheckDefaultChild);
      }
    }
  }, [isDefaultIndex]);
  return /* @__PURE__ */ import_react.default.createElement(import_Select.SelectContext.Provider, {
    value: selectContext
  }, moreThanOneChildren ? /* @__PURE__ */ import_react.default.createElement(import_Dropdown.Dropdown, {
    isOpen,
    refs,
    referenceProps,
    removeBtnMargin
  }, renderButtonContent()) : /* @__PURE__ */ import_react.default.createElement(import_Label.Label, {
    refs
  }, renderButtonContent()), /* @__PURE__ */ import_react.default.createElement(import_DropdownList.DropdownList, {
    isOpen,
    refs,
    onKeyDown,
    labelsRef,
    elementsRef,
    getFloatingProps,
    modifiedFloatingStyles,
    floatingMargin,
    context
  }, children));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Select,
  ...require("./Option/Option.component")
});
//# sourceMappingURL=Select.component.js.map